import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/join_total_img.png'
import _imports_1 from '@/assets/images/join_normal_img.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_contents" }
const _hoisted_3 = { class: "join_div" }
const _hoisted_4 = { class: "join_type_div" }
const _hoisted_5 = { class: "join_type_sub_div" }
const _hoisted_6 = { class: "join_type_sub_div" }




export default /*@__PURE__*/_defineComponent({
  __name: 'UserTypeView',
  emits: ["setType"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "page_header" }, "회원가입", -1)),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "page_header_line" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "join_desc" }, [
          _createElementVNode("div", null, "고객님께서 해당하는 회원의 종류를 선택해주세요"),
          _createElementVNode("div", null, "회원가입 후 최종 승인이 완료되면 정상적인 서비스 이용이 가능합니다."),
          _createElementVNode("div", null, "통합회원과 일반회원을 반드시 구분하여 가입 하시기 바라며, 로그인 시 자동으로 권한에 따라 컨텐츠가 구분됩니다.")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "join_label" }, "통합회원", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "join_sub_label" }, "(수주+수행)", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              class: "join_type_img",
              src: _imports_0,
              alt: ""
            }, null, -1)),
            _createElementVNode("div", {
              class: "join_btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('setType','통합')))
            }, "회원가입")
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "join_type_sub_line" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "join_label" }, "일반회원", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "join_sub_label" }, "(수주)", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("img", {
              class: "join_type_img",
              src: _imports_1,
              alt: ""
            }, null, -1)),
            _createElementVNode("div", {
              class: "join_btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('setType','수주')))
            }, "회원가입")
          ])
        ])
      ])
    ])
  ]))
}
}

})